import React from 'react';

export interface FooterRightWellProps {
  /** Content from context or undefined */
  content?: React.ReactNode;
}

/**
 * Container for right footer content (view commands)
 * Renders nothing if content is undefined
 */
export function FooterRightWell({ content }: FooterRightWellProps): JSX.Element | null {
  if (!content) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 overflow-x-auto pr-4">
      {content}
    </div>
  );
}
